/* eslint-disable import/extensions, import/no-unresolved */
import React from 'react';
import ReactHTMLParser from 'react-html-parser';
import { FONT_SIZE } from '@latitude/core/utils/constants';
import { StaticImage } from 'gatsby-plugin-image';

import {
  StyledHeroBranded,
  ImageBox,
  LeaderDetailsWrapper,
  DetailsContainer,
  StyledText,
  LeadershipPageLayout
} from '../../../components/Leadership';

export default props => {
  const title = 'Areti Rapakousios';
  const content =
    'Group General Manager, Internal Audit & Operational Excellence';

  return (
    <LeadershipPageLayout title={title} {...props}>
      <StyledHeroBranded
        title={title}
        text={ReactHTMLParser(content)}
        breadcrumbs={[
          {
            name: 'About us',
            href: '/about-us/'
          },
          {
            name: 'Our company',
            href: '/about-us/our-company/'
          },
          {
            name: 'Areti Rapakousios'
          }
        ]}
        imageContent={
          <ImageBox>
            <StaticImage
              alt={title}
              src="../images/areti-rapakousios-1.webp"
              width={450}
              quality={100}
              placeholder="dominantColor"
            />
          </ImageBox>
        }
      />
      <LeaderDetailsWrapper>
        <DetailsContainer display="flex">
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Areti joined Latitude Financial in March 2024 as Group General
            Manager, Internal Audit & Operational Excellence where she leads the
            company’s internal audit function and line-three risk management
            capabilities.
            <br />
            <br />
            She has 20 years of experience spanning consulting and industry
            roles, specialising in risk, governance and operational improvement.
            Before joining Latitude, Areti spent nine years at ANZ in senior
            leadership roles across risk management, operational excellence and
            transformation, working in Consumer Finance and Commercial Banking.
            Earlier in her career, she spent a decade with KPMG in risk
            consulting, advising organisations on risk, governance and process
            optimisation across sectors including retail, health insurance and
            mining.
          </StyledText>
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Areti has a Bachelor of Accounting from RMIT University and in 2010
            qualified as a CPA.
          </StyledText>
        </DetailsContainer>
      </LeaderDetailsWrapper>
    </LeadershipPageLayout>
  );
};
